import { Breadcrumb } from "client/Components";
import { ReactElement } from "react";
import { FolderNavigationStackItem } from "./useFolderNavigationStack";

export type WebDavBreadCrumbProps = {
	items: readonly FolderNavigationStackItem[];
	onOpenFolder: (item: FolderNavigationStackItem) => void;
};

export const WebDavBreadCrumb = (props: WebDavBreadCrumbProps): ReactElement => {
	const {
		items,
		onOpenFolder
	} = props;

	return (
		<Breadcrumb
			segments={items}
			onNavigate={onOpenFolder}
			trackingId="bread-crumb"
			getSegmentTrackingId={getSegmentTrackingId}
		/>
	);
};
WebDavBreadCrumb.displayName = "WebDavBreadCrumb";

function getSegmentTrackingId(item: FolderNavigationStackItem): string {
	return item.id;
}
